module.exports = __webpack_public_path__ + "static/02-7cc97eba340cfa70255c6a0f81ba893d.jpg";